import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-warning',
  templateUrl: './modal-warning.component.html',
  styleUrls: ['./modal-warning.component.scss']
})

export class ModalWarningComponent implements OnInit {

  @Input() text:string;
  @Output() finishDataPush = new EventEmitter<boolean>();

  constructor(public dialogRef: MatDialogRef<ModalWarningComponent>) { }

  ngOnInit(): void {
  }

  closeModal()
  {
    this.dialogRef.close(false);
  }

  handlerSubmit(){
    this.finishDataPush.emit(true);
  }

}
